import {
    fetchTermsConditions,
    fetchHnWAssessmentList,
    saveAssessmentAnswer,
    fetchHnWAssessmentHistoryLog,
} from '../../services/healthWellness/healthWellness.service';

// export const GUT_ASSESSMENT_ID = '041ba90c-2e69-41d6-99d0-8a3fa7a780a5x';
const waitCustomer = async (timeout = 15000) => {
    const start = Date.now();
    while (Date.now() - start < timeout) {
        const customer = JSON.parse(sessionStorage.getItem('customer') || 'null');
        if (customer) { return customer; }
        await new Promise(resolve => setTimeout(resolve, 200));
    }

    return null;
};
export const loadGutAssessmentData = async () => {
    const GUT_ASSESSMENT_ID = new URLSearchParams(window.location.search).get('id');

    if (!GUT_ASSESSMENT_ID) {
        window.location.replace(window.location.origin);
        return;
    }

    const [assessment, tc] = await Promise.all([
        fetchHnWAssessmentList(GUT_ASSESSMENT_ID, 'gut'),
        fetchTermsConditions('gutAssessment')
    ]);

    await waitCustomer();

    const logHistory = await fetchHnWAssessmentHistoryLog(GUT_ASSESSMENT_ID, null, 'gut');

    return {
        assessment,
        tc,
        logHistory: logHistory || [],
        hasHistory: (logHistory || []).length > 0
    };
};

export const sortGutQuestions = (assessmentData) => {
    return assessmentData?.hw_assessments_questions
        ?.slice()
        ?.sort((a, b) => a.display_order - b.display_order) || [];
};

export const buildGutAnswerData = (question, answer) => ({
    question_id: question._id,
    question_label: question.question_label,
    display_order: question.display_order,
    answer_text: answer.text,
    answer_value: answer.value,
});

export const buildGutAssessmentPayload = (answerList) => {
    return answerList.map(item => {
        const answerValue = Number(
            item?.answer?.[0]?.answer_value ??
            item?.answer_value ??
            0
        );

        return {
            _id: item.question_id || '',
            answer: item.answer || [
                {
                    answer_text: item.answer_text || '',
                    answer_value: answerValue
                }
            ],
            total_score: [answerValue]
        };
    });
};

export const calculateGutTotalScore = (gutAssessmentData) => {
    return gutAssessmentData.reduce((sum, item) => {
        return sum + Number(item.total_score[0] || 0);
    }, 0);
};

export const submitGutAssessmentAnswer = async (assessmentId, answerList) => {
    const gutAssessmentData = buildGutAssessmentPayload(answerList);
    const totalScore = calculateGutTotalScore(gutAssessmentData);

    const response = await saveAssessmentAnswer(
        assessmentId,
        gutAssessmentData,
        '',
        'DONE',
        {
            assessment_label: 'gutAssessment'
        },
    );

    const logHistory = await fetchHnWAssessmentHistoryLog(assessmentId, null, 'gut');

    return {
        response,
        totalScore,
        logHistory: logHistory || []
    };
};

export const getGutResult = (score, assessmentData) => {
    const suggestions = assessmentData?.metaData?.suggestions || [];

    const matchedIndex = suggestions.findIndex(
        item =>
            score >= item.score_from &&
            score <= item.score_to
    );

    if (matchedIndex === -1) return null;

    const matched = suggestions[matchedIndex];

    const classSuggestions = ['none', 'low', 'medium', 'high', 'veryhigh'];


    return {
        className: classSuggestions[matchedIndex],
        range: ` ${matched.score_from}-${matched.score_to}`,
        detail: matched.detail,
        desc: matched.desc,
        optionFirst: matched.optionFirst,
        optionFirstDetail: matched.optionFirstDetail,
        optionSecond: matched.optionSecond,
        optionSecondDetail: matched.optionSecondDetail,
        image: `/images/gut/guttest_score${matchedIndex + 1}.png`
    };
};

export const preloadImage = (src) => {
    return new Promise(resolve => {
        if (!src) return resolve();

        const img = new Image();

        img.onload = resolve;
        img.onerror = resolve;
        img.src = src;
    });
};